exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.identity[data-v-19ad1be2] {\n  width: 100%;\n  padding: 0.75rem;\n  box-sizing: border-box;\n}\n.boRradius[data-v-19ad1be2] {\n  border-radius: 0.4rem;\n}", ""]);

// exports
